import React, { useState } from 'react';
import { Modal, Input, Form, Space } from 'antd';
import { Link } from "react-router-dom";
function ChangePassword({ setChangePass, changePass}){
    const handleCancel=()=>{
        setChangePass(false)
    }
    return (<Modal
        title="Thiết lập đổi mật khẩu"
        className=" changePasswordModal modalStyle "
        visible={changePass}
        onCancel={handleCancel}
        footer={null}
    >
        <Form>
            <Form.Item className="formInput password"
                label="Mật khẩu hiện tại"
                name="pass_current"
            >
                <Space direction="vertical">
                    <Input.Password placeholder="Nhập mật khẩu hiện tại" />
                </Space>
            </Form.Item>
            <Form.Item className="formInput password"
                label="Mật khẩu mới"
                name="pass_new"
            >
                <Space direction="vertical">
                    <Input.Password placeholder="Nhập mật khẩu mới" />
                </Space>
            </Form.Item>
            <Form.Item className="formInput password"
                label="nhập lại mật khẩu mới"
                name="confirm_pass_new"
            >
                <Space direction="vertical">
                    <Input.Password placeholder="Nhập lại mật khẩu mới" />
                </Space>
            </Form.Item>    
            <Form.Item className="btnModal">
                <button className="btnStyle" >
                    Hoàn tất
                </button>
            </Form.Item>
        </Form>
    </Modal>)
}
export default ChangePassword;